<div class="column-text">


  <ng-content select=".customer-site-column-text-content"></ng-content>


</div>
